import React from 'react';
import { SellerProductBasicDetails } from './types';
import { useTranslation } from 'react-i18next';

import { useDispatch } from 'react-redux';
import { setModalId } from '../../../store/slices/publicSlice';
import Button from '../../atoms/Button';

type Props = {
  basicDetails?: SellerProductBasicDetails;
  productId: string;
};

export default function ProductActions({ basicDetails, productId }: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const actions = basicDetails?.actions;

  if (!actions) return null;

  return (
    <div
      className="flex items-center gap-4 flex-wrap w-full sm:w-auto"
      data-testid="product-actions-container"
    >
      <div
        className="flex items-center gap-2 flex-wrap w-full sm:w-auto"
        data-testid="product-actions-buttons"
      >
        {actions.canEdit && (
          <Button
            onClick={() =>
              dispatch(
                setModalId({
                  id: 'RETURN_PRODUCT_MODAL',
                  extraData: { productId },
                })
              )
            }
            data-testid="product-action-edit"
            variant="outline"
            size="md"
            className="rounded-xl bg-soft-background !border-soft-background "
          >
            {t('product.edit')}
          </Button>
        )}

        {actions.canReject && (
          <Button
            onClick={() =>
              dispatch(
                setModalId({
                  id: 'REJECT_PRODUCT_MODAL',
                  extraData: { productId },
                })
              )
            }
            data-testid="product-action-reject"
            variant="outline"
            size="md"
            className="rounded-xl bg-soft-background !border-soft-background "
          >
            {t('product.reject')}
          </Button>
        )}

        {actions.canApprove && (
          <Button
            onClick={() =>
              dispatch(
                setModalId({
                  id: 'APPROVE_PRODUCT_MODAL',
                  extraData: { productId },
                })
              )
            }
            data-testid="product-action-approve"
            size="md"
            className="rounded-xl bg-light-button-primary !border-light-button-primary "
          >
            {t('product.approve')}
          </Button>
        )}
      </div>
    </div>
  );
}
